
import { useEffect, useState } from "react";
import { appAPI } from "../../../api/service";
import toast from "react-hot-toast";

export function useSettings(setNavigation, navigation) {

    const [serverSettings, setServerSettings] = useState(null);
    const [loading, setLoading] = useState(false);

    async function getSettings() {
        try {
          const res = await appAPI.getSettings();
          if (res.error) {
            return toast.error(res.error);
          } else {
            if (!Array.isArray(res.settings)) {
              throw new Error("Invalid settings format");
            }
    
            for (let i = 0; i < res.settings.length; i++) {
              const setting = res.settings[i];
              if (!setting) continue;
    
              navigation.find((item) => {
                if (item.key_datas.includes(setting.data)) {
                  item.dataForRender.push({
                    title: setting.text ? setting.text : setting.data,
                    text: setting.text,
                    id: setting.id,
                    data: setting.data,
                    fromBackend: setting.data,
                    toBackend: setting.data,
                    type: "input",
                    value: setting.pkey,
                  });
                }
              });
            }
            setServerSettings(res.settings);
          }
        } catch (e) {
          console.log(e);
          setNavigation(false);
          return toast.error("Ошибка при получении данных");
        }
      }
    
      useEffect(() => {
        getSettings();
      }, []);

    return {
        serverSettings,
        loading
    }
}